<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20.096 16"
    aria-hidden="true"
  >
    <g
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.5"
    >
      <path stroke-linejoin="round" d="M11.699 14.75H.75V2.622h17.6v5.3" />
      <g>
        <path d="M16.345 9.25v6" data-name="Line 67" />
        <path d="M19.345 12.25h-6" data-name="Line 68" />
      </g>
      <path d="M4.24 6.75h3" data-name="Line 69" />
      <path d="M4.24 10.25h3" data-name="Line 73" />
      <path d="M11.346 6.75h3" data-name="Line 70" />
      <path d="M5.24.75v1.293" data-name="Line 71" />
      <path d="M14.24.75v1.293" data-name="Line 72" />
    </g>
  </svg>
</template>
